import { useQuery } from "react-query"
import { request } from "../util/request"

export function useHotBits(scene) {
  return useQuery(["song_stats_days", scene], () => fetchSongStatsDays(scene))
}

const fetchSongStatsDays = async (scene) => {
  return await request({
    queryKey: ["song_stats_days", { path: "/api/v1/song_stats_days", params: { scene } }],
  })
}
